import C_R from '../../../constants/routes';

export const getNavigationProps=(id)=> {
    return {
        INCIDENT_TEMPLATE_LINK: `${C_R.INCIDENT_PATH}?populateSR_id=${id}`,
        REQUEST_TEMPLATE_LINK: `${C_R.SR_PATH}?populateSR_id=${id}`,
        SUBMIT_INCIDENT: `${C_R.INCIDENT_PATH}?category_id=${id}`,
        SUBMIT_REQUEST: `${C_R.SR_PATH}?category_id=${id}`
    };
};



// WEBPACK FOOTER //
// ./components/utils/DynamicLink/linkHelper.js